import PartialReturnAlert from './PartialReturnAlert'

export default PartialReturnAlert
